import { faBatteryBolt, faChartLineDown, faChartLineUp } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';

import { colours } from '../../assets/colours';
import { boosters_energy, zappers_energy } from '../../shared/components/data';
import BarChart from '../components/BarChart';
import JournalBlock from '../components/JournalBlock';
import MotivationTile from '../components/MotivationTile';
import { seriesHasDisplayablePoint } from '../utils/chartDataAvailability';

function EnergyResults(props) {
  const { t } = useTranslation();
  const { assessScores, trackerScores, trackerJournals } = props.dataObj;
  const { assessDates, assessmentNumber } = props.pageObjRef?.current ?? {};

  return (
    <div className="results-container">
      {props.showAssessment && (
        <div className="results-row ">
          <BarChart
            title={t('D080')}
            icon={faBatteryBolt}
            data={assessScores.energy_level_data}
            average={assessScores.energy_level_data_average}
            units={t('D035')}
            yMaxLimit={10}
            average_type={t('D079')}
            width="half bars"
            color={colours.orange}
            modalText={[t('D093'), t('D089'), t('D094')]}
            openModal={props.openModal}
            assessmentNumber={assessmentNumber}
            assessDates={assessDates}
            outOfYMax
            showChartShellOnEmpty={!seriesHasDisplayablePoint(assessScores?.energy_level_data)}
          />
          <BarChart
            title={t('D081')}
            icon={faChartLineUp}
            data={assessScores.most_energetic_data}
            average={assessScores.most_energetic_data_average}
            units=""
            average_type={t('D079')}
            yMaxLimit={24}
            width="half bars"
            color={colours.green}
            modalText={[t('D092')]}
            openModal={props.openModal}
            assessmentNumber={assessmentNumber}
            assessDates={assessDates}
            isTime
            showChartShellOnEmpty={!seriesHasDisplayablePoint(assessScores?.most_energetic_data)}
          />
          <BarChart
            title={t('D082')}
            icon={faChartLineDown}
            data={assessScores.least_energetic_data}
            average={assessScores.least_energetic_data_average}
            units=""
            average_type={t('D079')}
            yMaxLimit={24}
            width="half bars"
            color={colours.red}
            modalText={[t('D091')]}
            openModal={props.openModal}
            assessmentNumber={assessmentNumber}
            assessDates={assessDates}
            isTime
            showChartShellOnEmpty={!seriesHasDisplayablePoint(assessScores?.least_energetic_data)}
          />
        </div>
      )}
      {!props.showAssessment && trackerScores?.energy?.energy_level.length > 0 && (
        <div className="results-row ">
          <BarChart // energy rating
            title={t('D080')}
            average={trackerScores.energy.energy_level_average}
            data={trackerScores.energy.energy_level}
            icon={faBatteryBolt}
            units={t('D035')}
            average_type={t('D079')}
            width="half bars"
            color={colours.orange}
            modalText={[t('D088'), t('D089'), t('D090')]}
            openModal={props.openModal}
            yMaxLimit={10}
            outOfYMax
          />
          <MotivationTile // energy enhancers
            title={t('D084')}
            colour={colours.green}
            data={trackerScores.energy.topEnhancers}
            valueArr={boosters_energy}
            width="quarter"
            modalText={[t('D087')]}
            openModal={props.openModal}
          />
          <MotivationTile // energy inhibitors
            title={t('D085')}
            colour={colours.red}
            data={trackerScores.energy.topInhibitors}
            valueArr={zappers_energy}
            width="quarter"
            modalText={[t('D086')]}
            openModal={props.openModal}
          />
          <JournalBlock
            width="quarter"
            startWith={8}
            journalArr={trackerJournals}
            openModal={props.openModal}
          />
        </div>
      )}
    </div>
  );
}
export default EnergyResults;
